import { useMemo } from "react";
import ToggleButtonGroup from "../../../Atoms/ToggleButtonGroup/ToggleButtonGroup";
import { TagSelectorProps } from "./TagSearchCard";

export function TagSelector({ tags, setTags, tagOptions }: TagSelectorProps) {
  const options = useMemo(
    () => Array.from(tagOptions).map(([id, label]) => ({ id, label })),
    [tagOptions]
  );

  return (
    <ToggleButtonGroup
      options={options}
      selected={tags}
      setSelected={setTags}
      style={{
        flexWrap: "wrap",
      }}
      buttonStyle={{
        width: "auto",
      }}
    />
  );
}

export const formatTags = ({
  tags,
  tagOptions,
}: Omit<TagSelectorProps, "setTags">) => {
  if (tags.size === 0) return "Anything";

  return Array.from(tags)
    .map((id) => tagOptions.get(id))
    .join(", ");
};
